import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const GiftRedeem = () => {
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    fullName: "",
    birthDate: "",
    birthTime: "",
    birthPlace: "",
  });

  // Fetch gift info
  useEffect(() => {
    const fetchGift = async () => {
      try {
        const res = await axios.get(
          `/api/payments/gift/${token}`
        );
        setOrder(res.data);
      } catch (err) {
        console.error(err);
        setError("This gift link is invalid or expired.");
      } finally {
        setLoading(false);
      }
    };

    fetchGift();
  }, [token]);

  const handleSubmit = async () => {
    setError("");
    try {
      await axios.post(
        `/api/payments/gift/${token}/redeem`,
        form
      );
      setSubmitted(true);
    } catch (err) {
      console.error(err);
      setError("Failed to redeem gift. Please try again.");
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        Loading your gift…
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center text-red-300">
        {error}
      </div>
    );
  }

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white text-center p-6">
        <div className="max-w-lg bg-purple-900 rounded-2xl p-8 shadow-xl">
          <h1 className="text-2xl font-bold mb-3">✨ Your Cosmic Blueprint is being prepared</h1>
          <p>
            Your personalised report is now being generated and will be emailed to you shortly.
          </p>
          <p className="mt-3 opacity-70">You don’t need to do anything else.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-black via-purple-950 to-indigo-950 text-white p-4">
      <div className="w-full max-w-lg bg-purple-900 bg-opacity-60 rounded-2xl p-6 shadow-xl space-y-4">
        <h1 className="text-2xl font-bold">🎁 You’ve been gifted a Cosmic Blueprint</h1>

        <p className="opacity-90">
          From: <strong>{order.fromName || "Someone who cares about you"}</strong>
        </p>

        {order.message && (
          <blockquote className="border-l-4 border-pink-400 pl-4 opacity-90">
            {order.message}
          </blockquote>
        )}

        <p className="mt-2 text-sm opacity-80">
          Please enter your birth details so we can create your personalised reading.
        </p>

        <div className="space-y-3">
          <input
            placeholder="Your full name"
            className="w-full bg-black bg-opacity-40 px-3 py-2 rounded"
            value={form.fullName}
            onChange={(e) => setForm({ ...form, fullName: e.target.value })}
          />
          <input
            type="date"
            className="w-full bg-black bg-opacity-40 px-3 py-2 rounded"
            value={form.birthDate}
            onChange={(e) => setForm({ ...form, birthDate: e.target.value })}
          />
          <input
            placeholder="Time of birth (optional)"
            className="w-full bg-black bg-opacity-40 px-3 py-2 rounded"
            value={form.birthTime}
            onChange={(e) => setForm({ ...form, birthTime: e.target.value })}
          />
          <input
            placeholder="Place of birth (city, country)"
            className="w-full bg-black bg-opacity-40 px-3 py-2 rounded"
            value={form.birthPlace}
            onChange={(e) => setForm({ ...form, birthPlace: e.target.value })}
          />

          <button
            onClick={handleSubmit}
            disabled={!form.fullName || !form.birthDate || !form.birthPlace}
            className="w-full bg-pink-500 hover:bg-pink-600 py-2 rounded-xl font-bold"
          >
            Generate My Blueprint ✨
          </button>
        </div>
      </div>
    </div>
  );
};

export default GiftRedeem;
